module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Food/French Bread-694178c058c68e9d3ee6a1d4e18b957e.svg";